import { Injectable, inject } from '@angular/core';
import { SiaSqlQueryApi } from '../apis/sia-sqlquery.api';

@Injectable({
  providedIn: 'root',
})
export class SiaSqlQueryService {
  private siaSqlQueryApi = inject(SiaSqlQueryApi);

  executeQuery(query: string, parameters: any = undefined, connectionString: string | null | undefined): Promise<any> {
    return this.siaSqlQueryApi.executeQuery(query, parameters, connectionString);
  }

  execSP(spName: string, parameters: any, connectionString: string | null | undefined): Promise<any> {
    return this.siaSqlQueryApi.execSP(spName, parameters, connectionString);
  }

  retriveTopN(viewSchema: string, viewName: string, n: number, connectionStringName: string = 'CoreDB'): Promise<any> {
    if (!viewSchema || !viewName || n <= 0 || viewName.trim() === '' || viewSchema.trim() === '') {
      return Promise.resolve([]);
    }
    return this.siaSqlQueryApi.retriveTopN(viewSchema, viewName, n, connectionStringName);
  }
}
